import React, { Component, useEffect, useState } from "react";
import axios from "axios";
import Button from 'react-bootstrap/Button';
import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import { Link } from "react-router-dom";

const access_token = localStorage.getItem("Auth");

function InvoiceList() {

    const [rowData, setRowData] = useState([]);
    const [columnDefs] = useState([
        { field: 'invoiceNumber', headerName: 'Invoice #', sortable: true, filter: true },
        { field: 'ticketId', headerName: 'Ticket ID' },
        { field: 'status', headerName: 'Status' },
        { field: 'dateOfIssue', headerName: 'Issue Date' },
        { field: 'dueDate', headerName: 'Due Date' },
        { field: 'orderCategory', headerName: 'Order Category' },
        { field: 'billFrom', headerName: 'Bill From' },
        { field: 'billTo', headerName: 'Bill To' },
        { field: 'subTotal', headerName: 'Sub Total' },
        { field: 'total', headerName: 'Total' },
        { field: 'currencySymbol', headerName: 'Currency' }
      ]);
    


    function getSops() {
        const headers = {
          "Content-Type": "text/plain",
          Authorization: `Bearer ${access_token}`,
        };
        axios
          .get("/api/invoice/invoices", {
            headers,
          })
          .then((data) => {
            if (data.status == "200") {
                setRowData(data.data.invoices);
            }
            
          })
          .catch((err) => console.log(err));
      }

    useEffect(() => {
        getSops();
      }, []);

  return (
    <> <div className="container-fluid">
        <div className="row">
            <div className="col-9">
            <blockquote className="blockquote mb-0">
  <p><i className="bi bi-receipt"></i> Invoice Manager</p>

</blockquote> 
<p className="text-muted mb-4">Track invoice like never before.</p>
            </div>
            <div className="col-3">
            <div className="d-grid gap-2 d-md-flex justify-content-md-end">
  <Link
                              to="/invoice"
                            ><button className="btn btn-dark pop me-md-2" type="button"><i className="bi bi-plus-circle"></i> Create Invoice</button></Link>
</div>
        
            </div>
            <div/>
        </div>
        
<br/>
      <div className="ag-theme-alpine" style={{ height: 500, width: '100%' }}>
      <AgGridReact
        rowData={rowData}
        columnDefs={columnDefs}
        pagination={true}
        paginationPageSize={10}
        defaultColDef={{
          resizable: true,
          sortable: true,
          filter: true,
        }}
      />
    </div>

   </div> 
    </>
  );
}

export default InvoiceList;
